import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import useAuthStore from './context/authStore';

import Navbar from './components/Navbar';
import Footer from './components/Footer';
import GlobalCampaignBar from './components/GlobalCampaignBar';
import CampaignPopup from './components/CampaignPopup';
import Certificate from './components/Certificate';
import ProtectedRoute from './components/ProtectedRoute';

import HomePage from './pages/HomePage';
import AuthPages from './pages/AuthPages';
import CoursesPage from './pages/CoursesPage';
import CourseDetailPage from './pages/CourseDetailPage';
import TeachersPage from './pages/TeachersPage';
import TeacherProfilePage from './pages/TeacherProfilePage';
import ReelsPage from './pages/ReelsPage';
import SubjectPage from './pages/SubjectPage';
import LessonPage from './pages/LessonPage';
import DashboardPage from './pages/DashboardPage';
import AdminPage from './pages/AdminPage';
import VerifyCertPage from './pages/VerifyCertPage';

import {
  PrivacyPage, TermsPage, TeacherAgreementPage,
  RefundPolicyPage, ShippingPolicyPage, ContactPage, AboutPage,
} from './pages/LegalPages';

function App() {
  const { init, loading } = useAuthStore();
  useEffect(() => { const u = init(); return u; }, [init]);

  if (loading && !window.location.pathname.includes('/cert-sample')) return (
    <div style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div className="spinner" />
    </div>
  );

  return (
    <BrowserRouter>
      <Toaster position="top-center" toastOptions={{ style: { fontFamily: 'Cairo, sans-serif', direction: 'rtl' } }} />

      <Routes>
        {/* ── Full-screen lesson page — no Navbar/Footer ── */}
        <Route
          path="/courses/:courseId/lessons/:lessonIndex"
          element={<ProtectedRoute><LessonPage /></ProtectedRoute>}
        />

        {/* ── All other pages with Navbar + Footer ── */}
        <Route path="*" element={<WithChrome />} />
      </Routes>
    </BrowserRouter>
  );
}

function WithChrome() {
  return (
    <>
      <GlobalCampaignBar />
      <CampaignPopup />
      <Navbar />
      <main style={{ minHeight: 'calc(100vh - 64px)' }}>
        <Routes>
          <Route path="/"                  element={<HomePage />} />
          <Route path="/login"             element={<AuthPages mode="login" />} />
          <Route path="/register"          element={<AuthPages mode="register" />} />
          <Route path="/courses"           element={<CoursesPage />} />
          <Route path="/courses/:id"       element={<CourseDetailPage />} />
          <Route path="/teachers"          element={<TeachersPage />} />
          <Route path="/teachers/:id"      element={<TeacherProfilePage />} />
          <Route path="/reels"             element={<ReelsPage />} />
          <Route path="/subjects/:slug"    element={<SubjectPage />} />
          <Route path="/dashboard/*"       element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
          <Route path="/admin/*"           element={<ProtectedRoute role="admin"><AdminPage /></ProtectedRoute>} />
          <Route path="/verify/:id"        element={<VerifyCertPage />} />

          {/* ── Legal & Info pages ── */}
          <Route path="/privacy"           element={<PrivacyPage />} />
          <Route path="/terms"             element={<TermsPage />} />
          <Route path="/teacher-agreement" element={<TeacherAgreementPage />} />
          <Route path="/refund-policy"     element={<RefundPolicyPage />} />
          <Route path="/shipping-policy"   element={<ShippingPolicyPage />} />
          <Route path="/contact"           element={<ContactPage />} />
          <Route path="/about"             element={<AboutPage />} />

          {/* ── Certificate Preview ── */}
          <Route path="/cert-sample"       element={
            <div style={{ padding: '60px 20px', background: '#f0f4f8', minHeight: '100vh', direction: 'rtl' }}>
              <Certificate
                certificate={{
                  id: 'CERT-2026-X',
                  studentName: 'أحمد محمد علي',
                  studentAvatar: 'https://i.pravatar.cc/150?u=student',
                  courseTitle: 'كورس الفيزياء المتقدمة — الثانوية العامة',
                  teacherName: 'د. محمد رضا',
                  teacherAvatar: 'https://i.pravatar.cc/150?u=teacher',
                  completedAt: new Date().toISOString()
                }}
                onClose={() => {}}
              />
            </div>
          } />

          <Route path="*"                  element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}

export default App;
